import {
  DraggableElement,
  DragHandle,
} from '@monorepo/shared/componentsV2/dragAndDrop/styled';
import styled from 'styled-components';

export const StyledListContainer = styled.div`
  width: 100%;
  max-height: 42vh;
  padding: 0.5rem 0;
  overflow-y: scroll;

  & ${DraggableElement} {
    width: calc(100% - 1rem);
    margin: 0.75rem 0.5rem;

    & ${DragHandle} {
      left: 0;
      opacity: 0.5;
      transform: scale(0.8);
    }

    &:hover ${DragHandle} {
      opacity: 1;
    }
  }
`;

export const StyledListItemLabel = styled.div`
  padding: 0.125rem 0;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: 2.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray666};
  white-space: pre-wrap;
  -webkit-text-stroke: 0.5px transparent;
`;

export const StyledNoResults = styled(StyledListItemLabel)`
  font-style: italic;
  font-weight: 400;
`;
